<template>
    <div class="page_content" aria-label="career idea Page Content">
    
        <div class="mt-5 pg_msg">
            <span>
                List career ideas you have that have sparked your interest as you’ve thought about what you might want to pursue next. List them in order, 
                with the top idea being the one you are most intrigued by. Try to create 3 career ideas. You have to create at least 1 to continue with your quests.
            </span>
        </div>
        
        <div class="mt-3">
            <div class="row page-heading mx-0">
                <div class="col-8 input module_heading">
                    <span class="module_icon icon-job" style="color: #157099;"></span>
                    <span class="module_type_name ace_sec_hd" role="heading" aria-level="1" aria-label="career ideas">Career Ideas</span>
                </div>
                <div class="col-4 submit btn-container text-right">
                    <button type="button" class="btn btn-primary" @click.prevent="create" aria-label="create career idea">create career idea</button>
                </div>
            </div>
            
            <div>
                <career-idea-list></career-idea-list>
            </div>
        </div>
        
    </div>
</template>

<script>
  import CareerIdeaList from './CareerIdeaList'

  export default {
    name: 'career-idea',
    components: {
      CareerIdeaList
    },

    methods: {
      create () {
        return this.$router.push({ name: 'careerIdeaCreate' })
      }
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/app/quest/components/CareerIdea.vue